const swaps = {
  state: {
    secondOk: localStorage.getItem('secondOk') || 1, //二次确认弹框 1需要二次确认 2不需要二次确认
    secondCloseOk: localStorage.getItem('secondCloseOk') || 1, //二次确认弹框 1需要二次确认 2不需要二次确认
  },
  mutations: {
    //设置二次弹框1弹出，2不弹出
    setSecondOk(state, payload) {
      state.secondOk = payload;
      localStorage.setItem('secondOk', payload);
    },

    //设置平仓二次弹框1弹出，2不弹出
    setSecondCloseOk(state, payload) {
      state.secondCloseOk = payload;
      localStorage.setItem('secondCloseOk', payload);
    },
  },
  getters: {

  },
  actions: {

  }
}
export default swaps



// WEBPACK FOOTER //
// ./src/store/swap/index.js